// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__314OK","header":"Messages_header__c7BIJ"};